import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { PasswordInput } from "../../components/PasswordInput";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../components/ui/dialog";

function SetPasswordDialog({ user, name, onClose }) {
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) return setError("La password deve avere almeno 8 caratteri.");
    if (pwd !== confirm) return setError("Le due password non coincidono.");
    setSaving(true);
    try {
      await api.post(`/admin/users/${user.id}/password`, { password: pwd });
      toast.success(`Password di ${name} aggiornata`);
      onClose();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="admin-set-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Cambia password · {name}</DialogTitle>
          <DialogDescription>{user.email} — scegli la nuova password (almeno 8 caratteri) e comunicala tu all'utente.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="admin-new-pwd">Nuova password</Label>
            <PasswordInput id="admin-new-pwd" value={pwd} onChange={(e) => setPwd(e.target.value)} autoComplete="new-password" data-testid="admin-new-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="admin-confirm-pwd">Conferma password</Label>
            <PasswordInput id="admin-confirm-pwd" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" data-testid="admin-confirm-password-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="admin-set-password-error">{error}</p>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="admin-set-password-cancel">Annulla</Button>
            <Button type="submit" disabled={saving} className="bg-blue-700 hover:bg-blue-800" data-testid="admin-set-password-submit">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salva password
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export function SetPasswordButton({ user, name, testid, compact }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="outline" size="sm" className={compact ? "h-8 gap-1" : "gap-1.5"} onClick={() => setOpen(true)} data-testid={testid} title="Cambia password">
        <KeyRound className="h-3.5 w-3.5" /> {compact ? "" : "Password"}
      </Button>
      {open && <SetPasswordDialog user={user} name={name} onClose={() => setOpen(false)} />}
    </>
  );
}
